const getStringFromSearchParam = (param: null | undefined | string | (string | null)[]) => {
  if (param === null || param === undefined) return undefined;
  if (typeof param === "string") return param;
  return (param.filter((item) => !!item) as string[])[0];
};

export default getStringFromSearchParam;
